import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import PhotographyPage from "@/pages/PhotographyPage";
import VideoClipsPage from "@/pages/VideoClipsPage";
import ShotTypePage from "@/pages/ShotTypePage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminGalleryList from "@/pages/admin/AdminGalleryList";
import AdminGalleryUpload from "@/pages/admin/AdminGalleryUpload";
import AdminGalleryBulkUpload from "@/pages/admin/AdminGalleryBulkUpload";
import AdminVideoBulkImport from "@/pages/admin/AdminVideoBulkImport";
import AdminGalleryEdit from "@/pages/admin/AdminGalleryEdit";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminInbox from "@/pages/admin/AdminInbox";
import AdminAccount from "@/pages/admin/AdminAccount";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<HomePage />} />
                <Route
                  path="/aerial"
                  element={
                    <ShotTypePage
                      shotType="aerial"
                      eyebrow="From the air"
                      title="Aerial & Drone"
                      intro="Drone photography and aerial films across UK highways, infrastructure, and construction, surveys, progress reports, and cinematic flyovers."
                      seoTitle="Aerial & Drone Photography"
                      seoDescription="Aerial and drone photography and film across UK highways, infrastructure, and construction projects."
                      path="/aerial"
                      testid="aerial-header"
                    />
                  }
                />
                <Route
                  path="/ground"
                  element={
                    <ShotTypePage
                      shotType="ground"
                      eyebrow="On site"
                      title="Ground & On-Site"
                      intro="People, plant, night works, depots, and structures, captured on the ground, in the thick of live highways projects."
                      seoTitle="Ground & On-Site Photography"
                      seoDescription="On-site photography and film, people, plant, night works, and structures across the UK highways sector."
                      path="/ground"
                      testid="ground-header"
                    />
                  }
                />
                <Route path="/photography" element={<PhotographyPage />} />
                <Route path="/video-clips" element={<VideoClipsPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="gallery" element={<AdminGalleryList />} />
                <Route path="gallery/new" element={<AdminGalleryUpload />} />
                <Route path="gallery/bulk" element={<AdminGalleryBulkUpload />} />
                <Route path="gallery/import-videos" element={<AdminVideoBulkImport />} />
                <Route path="gallery/:id" element={<AdminGalleryEdit />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="inbox" element={<AdminInbox />} />
                <Route path="account" element={<AdminAccount />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
